export const mqCheck = (() => {
    const mqLarge = window.matchMedia("(min-width: 992px)");
    mqLarge.addEventListener("change", mqHandler);

    function mqHandler(e) {
        console.log(e.matches);
        const mainNavigation = document.getElementById("mainNavigation");

        if (!mainNavigation) return;

        const toggleBtn = document.querySelectorAll("button[aria-controls='mainnav']")[0];
        const header = document.getElementById("header");
        const mainnav = document.getElementById("mainnav");

        toggleBtn.setAttribute("aria-expanded", "false");
        header.classList.remove("header--open");


        if (e.matches) {
            mainnav.setAttribute("aria-hidden", "false");
            mainnav.classList.remove("hidden");
        } else {
            mainnav.setAttribute("aria-hidden", "true");
            mainnav.classList.add("hidden");
        }
    }
    mqHandler(mqLarge);
})();
